export default "__VITE_ASSET__mlo3zdf8__"